export default {
  adsFormUrl: 'https://tally.so/r/nG1k82',
  contactEmail: 'rnb@beta.gouv.fr',
  heapId: process.env.NEXT_PUBLIC_HEAP_ID
};